import React from "react";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { PictureAsPdf, InsertDriveFile, TableChart } from "@mui/icons-material";

const PayInDownloadButtons = ({ filteredData }) => {
  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    doc.text("Pay In Report", 14, 10);
    doc.autoTable({
      head: [["Sr. No.", "Txn ID", "UTR No", "Date", "PayIn Amount", "Amount", "Status"]],
      body: filteredData.map((row, index) => [
        index + 1,
        row.txnid,
        row.easepayid,
        row.addedon,
        row.netAmountDebit || "N/A",
        row.amount,
        row.status === "success" ? "Successful" : "Failed",
      ]),
    });
    doc.save("pay_in_report.pdf");
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      filteredData.map((row, index) => ({
        "Sr. No.": index + 1,
        "Txn ID": row.txnid,
        "UTR No": row.easepayid,
        "Date": row.addedon,
        "PayIn Amount": row.netAmountDebit || "N/A",
        "Amount": row.amount,
        "Status": row.status === "success" ? "Successful" : "Failed",
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "PayIn Report");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(data, "pay_in_report.xlsx");
  };

  return (
    <Grid
      item
      xs={12}
      md={6}
      sx={{
        display: "flex",
        justifyContent: { xs: "center", md: "flex-end" },
        alignItems: "center",
        gap: 2,
      }}
    >
      <Tooltip title="Download as PDF" arrow>
        <IconButton
          onClick={handleDownloadPDF}
          sx={{
            color: "red",
            backgroundColor: "rgba(255, 0, 0, 0.1)",
            border: "2px solid rgba(255, 0, 0, 0.3)",
            borderRadius: "15px",
            transition: "0.3s",
            backdropFilter: "blur(5px)",
            "&:hover": {
              backgroundColor: "red",
              color: "white",
              boxShadow: "0px 4px 15px rgba(255, 0, 0, 0.7)",
              transform: "scale(1.1)",
            },
          }}
        >
          <PictureAsPdf fontSize="medium" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Download as CSV" arrow>
        <span>
          <CSVLink data={filteredData} filename="pay_in_report.csv" style={{ textDecoration: "none" }}>
            <IconButton
              sx={{
                color: "blue",
                backgroundColor: "rgba(0, 0, 255, 0.1)",
                border: "2px solid rgba(0, 0, 255, 0.3)",
                borderRadius: "15px",
                transition: "0.3s",
                backdropFilter: "blur(5px)",
                "&:hover": {
                  backgroundColor: "blue",
                  color: "white",
                  boxShadow: "0px 4px 15px rgba(0, 0, 255, 0.7)",
                  transform: "scale(1.1)",
                },
              }}
            >
              <InsertDriveFile fontSize="medium" />
            </IconButton>
          </CSVLink>
        </span>
      </Tooltip>

      <Tooltip title="Download as Excel" arrow>
        <IconButton
          onClick={handleDownloadExcel}
          sx={{
            color: "green",
            backgroundColor: "rgba(0, 128, 0, 0.1)",
            border: "2px solid rgba(0, 128, 0, 0.3)",
            borderRadius: "15px",
            transition: "0.3s",
            backdropFilter: "blur(5px)",
            "&:hover": {
              backgroundColor: "green",
              color: "white",
              boxShadow: "0px 4px 15px rgba(0, 128, 0, 0.7)",
              transform: "scale(1.1)",
            },
          }}
        >
          <TableChart fontSize="medium" />
        </IconButton>
      </Tooltip>
    </Grid>
  );
};

export default PayInDownloadButtons;
